import { retryAfterSeconds } from './httpResponse.js';

// Only this idempotent read may be replayed. Auth/profile writes are never retried.
export async function requestCurrentUser() {
    const controller = new AbortController();
    const deadline = Date.now() + 15000;
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
        for (let attempt = 0; attempt < 2; attempt++) {
            const response = await fetch(
                '/actions/avari/helpers/current-user',
                {
                    credentials: 'include',
                    cache: 'no-store',
                    signal: controller.signal
                }
            );
            if (response.ok) {
                const data = await response.json();
                if (controller.signal.aborted)
                    throw new Error('User fetch timed out');
                if (!['true', 'false'].includes(data?.isLoggedIn)) {
                    throw new Error('Invalid current-user response');
                }
                return data;
            }
            const error = new Error(
                `User fetch failed with status ${response.status}`
            );
            error.status = response.status;
            const seconds = retryAfterSeconds(
                response.headers?.get('Retry-After')
            );
            const delay = Math.max(1000, (seconds ?? 1) * 1000);
            if (
                response.status !== 429 ||
                attempt > 0 ||
                delay >= deadline - Date.now()
            ) {
                throw error;
            }
            await new Promise((resolve, reject) => {
                const abort = () => {
                    clearTimeout(timer);
                    reject(error);
                };
                const timer = setTimeout(() => {
                    controller.signal.removeEventListener('abort', abort);
                    resolve();
                }, delay);
                controller.signal.addEventListener('abort', abort, {
                    once: true
                });
                if (controller.signal.aborted) abort();
            });
        }
    } finally {
        clearTimeout(timeout);
    }
}
